import React, { useState, useEffect } from 'react';
import api from '@/lib/api';

const avatarColors = [
  'bg-red-500', 'bg-blue-500', 'bg-green-500', 'bg-purple-500',
  'bg-orange-500', 'bg-red-500', 'bg-purple-500', 'bg-rose-500',
  'bg-cyan-500', 'bg-amber-600'
];

function getColorFromName(name) {
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return avatarColors[Math.abs(hash) % avatarColors.length];
}

function getInitials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function UserAvatar({ fotoPath, nome, size = 'md', className = '' }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!fotoPath) { setBlobUrl(null); return; }
    let cancelled = false;
    api.get(`/users/foto/${fotoPath}`, { responseType: 'blob' })
      .then(res => {
        if (!cancelled) setBlobUrl(URL.createObjectURL(res.data));
      })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [fotoPath]);

  useEffect(() => {
    return () => { if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [blobUrl]);

  // Formato 3x4 (aspect-ratio 3:4)
  const sizeClasses = {
    xs: 'w-5 h-[26px] text-[9px]',
    sm: 'w-7 h-[37px] text-[10px]',
    md: 'w-9 h-[48px] text-xs',
    lg: 'w-12 h-[64px] text-sm',
    xl: 'w-16 h-[85px] text-xl',
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;

  if (blobUrl && !error) {
    return (
      <img
        src={blobUrl}
        alt={nome || 'Foto'}
        className={`${sizeClass} rounded-md object-cover flex-shrink-0 border border-gray-200 dark:border-gray-600 ${className}`}
        data-testid="user-avatar-img"
      />
    );
  }

  const color = getColorFromName(nome);
  const initials = getInitials(nome);
  return (
    <div
      className={`${sizeClass} ${color} rounded-md flex items-center justify-center text-white font-bold flex-shrink-0 border border-white/20 ${className}`}
      data-testid="user-avatar-initials"
      title={nome}
    >
      {initials}
    </div>
  );
}
